import type { AnswerFragment } from '../../../present/activity-answers.graphql.generated';
import {
  FillInBlanksResponseAnswer,
  FillInBlanksSentence,
} from '../fill-in-blanks.constants';
import { ACTIVITIES_ANSWER_TEXT } from 'global/constants';
import { InquisitiveActivitiesAnswerType } from 'global/graphql/scalars.type';
import { getRichtextAnswer } from '../../shared/logic/get-richtext-answer';
import type { SuggestedAnswerFragment } from '../../suggested-answers/suggested-answers.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export type AnswerMap = {
  [key: string]: FillInBlanksResponseAnswer | undefined;
};

export const getFillInBlanksSentenceAnswer = (
  sentence: FillInBlanksSentence,
  fieldAnswers?: (
    | AnswerFragment
    | Pluck<SuggestedAnswerFragment, 'suggestedAnswers'>
  )[]
): AnswerMap => {
  const answers: AnswerMap = {};
  sentence.answerBlocks.forEach(block => {
    const answer = fieldAnswers?.find(
      answer => answer.answerReferences?.id === block.itemId
    );
    answers[block.itemId] = answer
      ? {
          uuid: answer.uuid,
          componentId: answer.componentId,
          activityId: answer.activityId,
          answerType: answer.answerType,
          createdAt: 'createdAt' in answer ? answer.createdAt : undefined,
          updatedAt: 'updatedAt' in answer ? answer.updatedAt : undefined,
          studentId: 'studentId' in answer ? answer.studentId : undefined,
          answer: {
            answerType:
              ACTIVITIES_ANSWER_TEXT as InquisitiveActivitiesAnswerType,
            richtext: getRichtextAnswer(answer),
          },
          answerReferences: {
            id: answer.answerReferences?.id,
          },
        }
      : undefined;
  });
  return answers;
};
